module.exports = __webpack_public_path__ + "static/media/01.4135e062.png";